// library imports
import { useDispatch } from "react-redux";

// User Component imports
import { ApiRequest } from "_core/apis/ApiRequest";
import { setApiTimestamp, setTransactionData } from "_core/slices/datas/TransactionSlice";


const AdminUpdateUserPromptApi = () => {
    const dispatch = useDispatch();

    // API固有の設定、URLとリクエスト
    const url = "/admin/update_user_prompt";

    /**
     * API実行
     * @param {File} promptFile プロンプトを記載したファイル
     * @returns リクエスト結果
     */
    const ExecAdminUpdateUserPromptApi = async (promptFile) => {

        // 必要なリクエストを定義
        const requestParams = {};
        const requestBinaryParams = {
            user_prompt: {
                file: promptFile,
                filename: promptFile.name
            }
        }

        let response = null;
        let error = null;

        // console.log(url + "API開始");
        try {
            response = await ApiRequest({ url:url, requestParams:requestParams, requestBinaryParams:requestBinaryParams });
            // console.log(response);
        } catch (e) {
            // console.log(e);
            error = e;
        } finally {
            // console.log(url + "　API終了");
        }

        // レスポンスがあれば、データ更新
        if (response !== null && response.error_code === 0) {
            dispatch(setApiTimestamp(response['now_time']));
            if (response['t_asset_list'] != null) {
                dispatch(setTransactionData({
                    tAssetList: response['t_asset_list']
                }));
            }
            if (response['t_user_add'] != null) {
                dispatch(setTransactionData({
                    tUserAdd: response['t_user_add']
                }));
            }
        }

        return { response, error };
    };

    return ExecAdminUpdateUserPromptApi;
};

export default AdminUpdateUserPromptApi;